module.exports = __webpack_public_path__ + "img/personal_icon_adress@2x.4fb8883c.png";